import { DatePicker } from "antd";
import { DateFormats } from "../../types/typesConstants";

export const DatePickerUi = ({ ...props }) => {
  return <DatePicker format={DateFormats.frontend} {...props} />;
};
